import { LinkType } from '@/shared/api-client/models/link-type';
import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';

export type KnownTargetType =  'Undefined' | 'Facebook' | 'Instagram' | 'LinkedIn' | 'Twitter' | 'YouTube' | 'Email' | 'Webpage';

@Component
export default class LinkIconComponent extends Vue {

    @Prop() public type!: LinkType;
    @Prop() public href!: string;
    @Prop() public show!: boolean;

    /**
     *
     */
    constructor() {
        super();
    }

    public get val(): KnownTargetType {

        if (this.type === 'Email') {
            return 'Email';
        }

        if (this.type === 'Url') {

            const hostname = this.extractDomainName(this.href);

            switch (hostname) {

                case 'facebook.com':
                    return 'Facebook';

                case 'linkedin.com':
                    return 'LinkedIn';

                case 'twitter.com':
                    return 'Twitter';

                case 'instagram.com':
                    return 'Instagram';

                case 'youtube.com':
                    return 'YouTube';

                default:
                    return 'Webpage';
            }
        }

        return 'Undefined';
    }

    private extractDomainName(url: string): string | undefined {

        let domainName;

        const hostNameMatch = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?=]+)/im);

        if (hostNameMatch) {
            domainName = hostNameMatch[1];

            const domainNameMatch = domainName.match(/^[^.]+\.(.+\..+)$/);

            if (domainNameMatch) {

                domainName = domainNameMatch[1];
            }
        }

        return domainName;

    }
}
